import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.create-credit-card-item.presenters.CreateCreditCardItemFormPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  // Exact Angular parity string (BHV-016).
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'The credit card item has been updated successfully.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to create the credit card item.',
  },
})
